import { render, staticRenderFns } from "./faturamento-icon.vue?vue&type=template&id=63101d11&"
import script from "./faturamento-icon.vue?vue&type=script&lang=js&"
export * from "./faturamento-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports